import request from '../../axios/axiosconfig.js'

/**
 * 查询首页统计数据
 * @returns 
 */
  export function getIndexData() {
  return request({
    url: '/ps/index/indexData',
    method: 'get'
  })
}

/**
 * 获取首页统计图数据
 * @param {params}  
 * @returns  
 */
 export function getChart(params) {
  return request({
    url: '/ps/index/orderChart',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/index/index.js